export const POS_LABEL_COLOR = '#D3D3D3'
export const POS_STYLE_BUTTON_COLOR = '#ffff99'
export const DEFAULT_LAYOUT_BUTTON_COLOR = '#306090'

export const LAYOUT_BUTTON_COLORS = [
  '#E57373',
  '#BA68C8',
  '#2196F3',
  '#4CAF50',
  '#00BCD4',
  '#0D47A1',
  '#FFEB3B',
  '#FF9800',
  '#795548',
  DEFAULT_LAYOUT_BUTTON_COLOR
]

export const POS_COLORS = [
  ...LAYOUT_BUTTON_COLORS,
  '#90EE90',
  '#D2B48C',
  '#404040',
  POS_LABEL_COLOR,
  '#FFF',
  '#32306c',
  '#ffc0cb',
  POS_STYLE_BUTTON_COLOR
]
